import './title-lockup-subtitle.css';
import { jsx } from 'react/jsx-runtime';
import styles from './title-lockup-subtitle.module.scss.js';
import 'react';
import { validateSurface } from '../../globals.js';
import '../../_virtual/_tslib.js';
import '../../utilities/use-viewport/index.js';
import 'react-focus-lock';
import 'react-dom';
import '../../buttons/button-icon/index.js';
import '../../icons/component-icons/info/index.js';
import { TrailingTooltip } from '../../tooltips/trailing-tooltip/index.js';
import { calculateTooltipSize } from './utils/calculate-tooltip-configs/tooltip-size.js';
import { calculateTooltipText } from './utils/calculate-tooltip-configs/tooltip-text.js';

/**
 * @component TitleLockup
 * @package TypeLockups
 */
const TitleLockupSubtitle = (props) => {
    const { size, primitive = 'h2', children, surface: surfaceProp = 'lightPrimary', color, tooltip, bold, numberOfLines, id, 'data-testid': testID = 'subtile', } = props;
    const surface = validateSurface(surfaceProp);
    const SubtitleComponent = primitive;
    const subtitleStyles = [styles.subtitle];
    /* istanbul ignore else -- @preserve */
    if (size) {
        subtitleStyles.push(bold ? styles[`${size}-bold`] : styles[`${size}-regular`]);
    }
    const getColor = () => {
        if (color)
            return color;
        return `var(--vds-color-element-primary-on${surface.toLowerCase()})`;
    };
    const { tooltipKind, tooltipSize } = calculateTooltipText(size);
    return (jsx("div", { id: id ? `${id}-wrapper` : undefined, className: styles.subtitleWrapper, "data-testid": `${testID}-wrapper`, children: tooltip ? (jsx(TrailingTooltip, { text: {
                size: tooltipSize,
                kind: tooltipKind,
                primitive,
                color: getColor(),
                bold,
            }, surface: surface, tooltip: Object.assign(Object.assign({}, tooltip), { iconColor: getColor(), ariaLabel: tooltip.ariaLabel, closeButtonText: tooltip.closeButtonText, containerId: tooltip.containerId, size: calculateTooltipSize(size, tooltip && tooltip.size), title: tooltip.title, children: tooltip.children }), id: id, children: children })) : (jsx(SubtitleComponent, { className: subtitleStyles.join(' '), style: Object.assign({ color: getColor() }, (numberOfLines && {
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: numberOfLines,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            })), id: id, "data-testid": testID, children: children })) }));
};
TitleLockupSubtitle.displayName = 'TitleLockupSubtitle';

export { TitleLockupSubtitle as default };
